module.exports = __webpack_public_path__ + "img/28.d650b751.jpg";